var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"rewards-exclusive-pill-container"},[_c('img',{staticClass:"pepper-badge",attrs:{"src":_vm.pepperBadgeUrl},on:{"load":_vm.onBadgeLoad}}),_c('div',{staticClass:"pill"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }